import { ref, unsafeText } from "./names"

export const scoreFieldType = (scores: Record<string, number>): "INT" | "REAL" =>
  Object.values(scores).every((v) => Number.isInteger(v)) ? "INT" : "REAL"

/**
 * The CALC expression that gives each respondent the score of the option
 * they chose: `<<a>> ? 5 : (<<b>> ? 4 : missing)`. Options without a score
 * (the exceptions) and people without an answer come out as missing.
 * `order` is the option order of the question. Null when nothing can be scored.
 */
export const scoreExpression = (
  scores: Record<string, number>,
  optionPaths: Record<string, string>,
  order: string[]
): string | null => {
  const labels = order.filter(
    (l) => l in scores && !!optionPaths[l] && !unsafeText(optionPaths[l])
  )
  if (labels.length === 0) return null
  return labels.reduceRight(
    (rest, l) =>
      `${ref(optionPaths[l])} ? ${scores[l]} : ${rest === "missing" ? rest : `(${rest})`}`,
    "missing"
  )
}
